/** 引数に ID の配列を渡すと、ID の最大値を返す関数。 */
export const getMaxId = (ids: number[]) =>
  ids.reduce((accumulator, currentValue) => Math.max(accumulator, currentValue), 0);

/** 引数に ID の配列を渡すと、次に使える ID を返す関数。 */
export const getNextId = (ids: number[]) => getMaxId(ids) + 1;
